import BaseStore from '@src/utils/store/base-store';
import toWebpImage from '@src/utils/to-webp-image';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { observable } from 'mobx';
import { useEffect } from 'react';

class FeatureScreenStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable isActive = false;

  // 获取当前活跃的视频元素（避免循环复制问题）
  getCurrentActiveVideo = () => {
    if (!this.featureSwiperStore.swiperRef?.current?.swiper) {
      return null;
    }

    const swiper = this.featureSwiperStore.swiperRef.current.swiper;
    const activeSlide = swiper.slides[swiper.activeIndex];

    if (activeSlide) {
      // 在活跃的slide中查找video元素
      const videoElement = activeSlide.querySelector('video');

      // 确保当前video有事件监听器（包括复制的video）
      if (videoElement) {
        this.addEndedListener(videoElement);
      }

      return videoElement;
    }

    return null;
  };

  // 为单个视频添加ended事件监听器
  addEndedListener = video => {
    if (video && !video._endedListenerAdded) {
      video._endedListenerAdded = true;
      video.addEventListener('ended', () => {
        this.featureSwiperStore.goNext();
      });
    }
  };

  @observable
  swiperData = [
    {
      swiperImg: toWebpImage(require('./images/videopic/01.jpg')),
      video_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202506/1749733550164_byzc.mp4',
      descriptionImg: toWebpImage(require('./images/videopic/desc-01.png'))
    },
    {
      swiperImg: toWebpImage(require('./images/videopic/02.jpg')),
      video_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202506/1749733550164_jbDIY.mp4',
      descriptionImg: toWebpImage(require('./images/videopic/desc-02.png'))
    },
    {
      swiperImg: toWebpImage(require('./images/videopic/03.jpg')),
      video_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202506/1749733550164_msmk.mp4',
      descriptionImg: toWebpImage(require('./images/videopic/desc-03.png'))
    },
    {
      swiperImg: toWebpImage(require('./images/videopic/04.jpg')),
      video_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202506/1749733550164_jxyDIY.mp4',
      descriptionImg: toWebpImage(require('./images/videopic/desc-04.png'))
    }
  ];

  @observable swiperActionIndex = 0;

  // 轮播实际内容展示使用的store
  @observable
  featureSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      slidesPerView: 1
    }
  });

  // 实际控制轮播拖动滚动的store
  @observable
  swiperControlStore = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      autoplay: false,
      slidesPerView: 1
    }
  });

  // 轮播切换锚点store
  @observable
  anchorSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      // loop: true,
      autoplay: false,
      slidesPerView: 3,
      centeredSlides: true,
      slideToClickedSlide: true,
      loopedSlides: 5
    }
  });

  videoPause = videoElm => {
    if (videoElm && typeof videoElm.pause === 'function') {
      videoElm.pause();
    }
  };

  // 暂停所有视频（包括循环复制的视频）
  pauseAllVideos = () => {
    // 暂停DOM中所有的video元素（包括原始和复制的）
    const allVideos = document.querySelectorAll('video');
    allVideos.forEach(video => {
      this.videoPause(video);
    });
  };

  videoPlay = videoElm => {
    if (videoElm && typeof videoElm.play === 'function') {
      // 先暂停所有视频
      this.pauseAllVideos();
      // 将当前视频重置到开头
      videoElm.currentTime = 0;
      // 再播放当前视频
      videoElm.play();
    }
  };

  use() {
    super.use();

    useEffect(
      () => {
        this.swiperActionIndex = this.featureSwiperStore.activeIndex;
      },
      [this.featureSwiperStore.activeIndex]
    );

    useEffect(
      () => {
        this.swiperActionIndex = this.swiperControlStore.activeIndex;
      },
      [this.swiperControlStore.activeIndex]
    );

    useEffect(
      () => {
        this.swiperActionIndex = this.anchorSwiperStore.activeIndex;
      },
      [this.anchorSwiperStore.activeIndex]
    );

    useEffect(
      () => {
        this.featureSwiperStore.activeIndex = this.swiperActionIndex;
        this.swiperControlStore.activeIndex = this.swiperActionIndex;
        this.anchorSwiperStore.activeIndex = this.swiperActionIndex;

        // 使用当前活跃的video元素，更加可靠
        setTimeout(() => {
          const videoElement = this.getCurrentActiveVideo();
          if (videoElement) {
            this.videoPlay(videoElement);
          }
        }, 100); // 小延迟确保swiper状态更新完成
      },
      [this.swiperActionIndex]
    );
  }
}

export default FeatureScreenStore;
